//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'CatalogSpoiler',

	props: {
		duration: {
			type: Number,
			default: 200
		},

		itemsCount: {
			type: Number,
			default: 0
		},

		noHead: {
			type: Boolean,
			default: false
		},

		noBorder: {
			type: Boolean,
			default: false
		},

		show: {
			type: Boolean,
			default: false
		}
	},

	data: function data() {
		return {
			isOpen: false,
			styles: {},
			visibleCount: 5,
			cutHeight: 148
		};
	},


	computed: {
		lang: function lang() {
			return this.$store.state.settings.lang;
		},
		cutTitle: function cutTitle() {
			return this.$lang('filterCut', null, this.lang);
		},
		uncutTitle: function uncutTitle() {
			return this.$lang('filterUncut', null, this.lang);
		},
		hasCut: function hasCut() {
			return this.itemsCount > this.visibleCount;
		},
		closeHeight: function closeHeight() {
			return this.hasCut ? this.cutHeight : 0;
		}
	},

	methods: {
		open: function open() {
			var _this = this;

			this.styles = { height: this.$refs.inner.offsetHeight + 'px' };

			setTimeout(function () {
				_this.styles = null;
				_this.isOpen = true;
			}, this.duration);
		},
		close: function close(h) {
			var _this2 = this;

			this.styles = { height: this.$refs.inner.offsetHeight + 'px' };

			setTimeout(function () {
				_this2.styles = { height: h };
			}, 16);

			setTimeout(function () {
				_this2.styles = null;
				_this2.isOpen = false;
			}, this.duration);
		},
		toggle: function toggle(closeHeight) {
			var h = typeof closeHeight === 'number' ? closeHeight : this.closeHeight;

			if (this.$refs.body.offsetHeight === h) this.open();else this.close(h);
		}
	},

	watch: {
		show: function show(val) {
			this.toggle();
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CatalogSpoiler.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CatalogSpoiler.vue
// module chunks = 0